import { render, staticRenderFns } from "./podChargeForm.vue?vue&type=template&id=62f75463&"
import script from "./podChargeForm.vue?vue&type=script&lang=js&"
export * from "./podChargeForm.vue?vue&type=script&lang=js&"
import style0 from "./podChargeForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f75463')) {
      api.createRecord('62f75463', component.options)
    } else {
      api.reload('62f75463', component.options)
    }
    module.hot.accept("./podChargeForm.vue?vue&type=template&id=62f75463&", function () {
      api.rerender('62f75463', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/FrightSurCharge/components/podChargeForm.vue"
export default component.exports